module.exports = __webpack_public_path__ + "bacac546bcb9352f46bd01121e9fa84f.fbx";